import { Carousel, Col, Row } from "antd";
import { Fade } from "react-awesome-reveal";
import { withTranslation } from "react-i18next";

import { Button } from "../../common/Button";
import {
  ButtonWrapper,
  Content,
  ContentSection,
  ContentWrapper,
  MinTitle,
  ServiceWrapper,
  StyledRow,
} from "./styles";
import { ContentBlockProps } from "./types";

const ContentBlock = ({
  images,
  title,
  content,
  section,
  button,
  t,
  id,
  direction,
  tag,
}: ContentBlockProps) => {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    element.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <ContentSection>
      <Fade direction={direction} triggerOnce>
        <StyledRow
          justify="space-between"
          align="middle"
          id={id}
          direction={direction}
        >
          <Col lg={11} md={11} sm={12} xs={24}>
            <Carousel autoplay>
              {images.map((image) => (
                <div>
                  <img
                    src={`/img/icons/${image}`}
                    alt="Imagem do diário"
                    width="100%"
                    height="100%"
                  />
                </div>
              ))}
            </Carousel>
          </Col>
          <Col lg={11} md={11} sm={11} xs={24}>
            <ContentWrapper>
              <h6>{t(title)}</h6>
              {tag && (
                <div
                  style={{
                    padding: "5px",
                    backgroundColor: "#B3CAE8",

                    height: "100%",
                    color: "white",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                  }}
                >
                  {tag}
                </div>
              )}
              <Content>{t(content)}</Content>
              {direction === "right" ? (
                <ButtonWrapper>
                  {typeof button === "object" &&
                    button.map(
                      (
                        item: {
                          color?: string;
                          title: string;
                          scroll?: string;
                          href?: string;
                        },
                        id: number
                      ) => {
                        return (
                          <a href={item.href} target="_blank">
                            {" "}
                            <Button
                              key={id}
                              color={item.color}
                              onClick={() =>
                                item.scroll && scrollTo(item.scroll)
                              }
                            >
                              {t(item.title)}
                            </Button>
                          </a>
                        );
                      }
                    )}
                </ButtonWrapper>
              ) : (
                <ServiceWrapper>
                  <Row justify="space-between">
                    {typeof section === "object" &&
                      section.map(
                        (
                          item: {
                            title: string;
                            content: string;
                            icon: string;
                          },
                          id: number
                        ) => {
                          return (
                            <Col key={id} span={7}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              >
                                <img
                                  src={`/img/icons/${item.icon}`}
                                  width="60px"
                                  height="60px"
                                  alt="icon"
                                />
                              </div>
                              <MinTitle>{t(item.title)}</MinTitle>
                            </Col>
                          );
                        }
                      )}
                  </Row>
                </ServiceWrapper>
              )}
            </ContentWrapper>
          </Col>
        </StyledRow>
      </Fade>
    </ContentSection>
  );
};

export default withTranslation()(ContentBlock);
